import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (!data?.name?.length > 0)
        response.push(<Box>Digite o nome do Documento.</Box>)

    if (!data?.number?.length > 0)
        response.push(<Box>Digite o número.</Box>)

    if (!data?.type)
        response.push(<Box>Selecione um tipo.</Box>)
    
    if (response.length === 0)
        return ''

    return (response)
}

export default validateData